import { BarDataProps } from '@components/horizontal-percentage-bar/src/horizontal-percentage-bar.type';
import { ALL_BOOKINGS_OPTION, EventReportBookingOptions } from '@contexts/event-report/event-report-context.type';
import { EventReportDataType, EventSalesStatsAdmissions, EventSalesStatsResponse } from '@domain/event-report';
import { calculatePercentage } from '@utils/calculate-percentage';
import { TFunction } from 'i18next';

import { BADGE_LIST_ADMISSIONS, EVENT_REPORT_TAB_TYPE_BOOKING, EVENT_REPORT_TAB_TYPE_REVENUE } from './config';
import { createFilteredAdmissionBadges } from '.';

export const formatDataBookingMixSection = ({
  data,
  t,
  bookingFilterValue = ALL_BOOKINGS_OPTION,
}: {
  data: EventSalesStatsResponse;
  t: TFunction<'translation', undefined>;
  bookingFilterValue?: EventReportBookingOptions;
}) => {
  const totalQuantity = data?.event.soldItems[bookingFilterValue] ?? 0;
  const totalRevenue = data?.event.revenue[bookingFilterValue] ?? 0;

  const mapHorizontalBarData = (
    itemValue: typeof EVENT_REPORT_TAB_TYPE_BOOKING | typeof EVENT_REPORT_TAB_TYPE_REVENUE
  ) =>
    BADGE_LIST_ADMISSIONS.reduce((acc: BarDataProps[], badge) => {
      const badgeData = data?.[badge.id as keyof EventSalesStatsAdmissions];
      if (!badgeData) return acc;
      const totalValue = itemValue === EVENT_REPORT_TAB_TYPE_BOOKING ? totalQuantity : totalRevenue;
      const percentage = +(
        calculatePercentage(
          badgeData[itemValue][bookingFilterValue] + badgeData.addOns[itemValue][bookingFilterValue],
          totalValue
        ) ?? 0
      ).toFixed(2);
      if (percentage === 0) return acc;

      const item = {
        id: badge.id as EventReportDataType,
        color: badge.color,
        isActive: true,
        percentage,
        quantity: badgeData[itemValue][bookingFilterValue],
        admissions: [
          ...badgeData.offers.map((offer) => ({
            title: offer.name ?? t(badge.title),
            amount: offer.revenue[bookingFilterValue],
            quantity: offer.soldItems[bookingFilterValue],
          })),
        ],
      };
      return [...acc, item];
    }, []);

  return {
    data: [
      {
        title: t('offers:admissionQuantityLabel'),
        subtitle: `eventReport:${bookingFilterValue}Label`,
        total: totalQuantity,
        type: EVENT_REPORT_TAB_TYPE_BOOKING,
        horizontalBarData: mapHorizontalBarData('soldItems'),
      },
      {
        title: t('analytics:totalRevenue'),
        subtitle: `eventReport:${bookingFilterValue}Label`,
        total: totalRevenue,
        type: EVENT_REPORT_TAB_TYPE_REVENUE,
        horizontalBarData: mapHorizontalBarData('revenue'),
      },
    ],
    categories: createFilteredAdmissionBadges(t, data, bookingFilterValue),
  };
};
